<template>
  <div id="box">
    <!-- -->
    <!-- <div class="backShow"></div> -->

    <div
      class="TopNewBox"
      v-if="shopShow"
      v-on:click="toShopIndex(attionShopFirst)"
    >
      <div
        class="shopNameNew"
        :style="
          attionShopFirst.shop_images
            ? 'background-image:url(' +
              CShttp +
              attionShopFirst.shop_images +
              ') !important'
            : ''
        "
      >
        <div class="shopImg">
          <img :src="CShttp + attionShopFirst.shop_icon_image" alt />
        </div>
        <div class="Name">
          <div class="NameText">{{ attionShopFirst.name }}</div>
          <div class="shopInfo">
            <div>
              <span>{{ attionShopFirst.shop_class_list }}</span>
              <span class="shopInfoCenter">|</span>
              <span
                >月销量{{
                  attionShopFirst.xiaoliang ? attionShopFirst.xiaoliang : 0
                }}</span
              >
            </div>
          </div>
          <div class="shopJuli">
            {{ (attionShopFirst.juli / 1000).toFixed(2) }}km
          </div>
        </div>
      </div>
      <img class="topLogo" :src="CShttp + (attionShopFirst.top_img?attionShopFirst.top_img:attionShopFirst.shop_icon_image)" alt="" />
    </div>
    <div
      v-if="
        attionShopFirst.coupon_list && attionShopFirst.coupon_list.length > 0
      "
      class="swiperBox"
      :style="
        attionShopFirst.coupon_list && attionShopFirst.coupon_list.length > 0
          ? ''
          : 'margin-top:1.4rem'
      "
    >
      <swiper :options="swiperOption">
        <swiper-slide
          v-for="(item, index) in attionShopFirst.coupon_list"
          :key="index"
        >
          <div class="swiperTicket">
            <div
              class="ticketMoney"
              v-if="item.category == '免费券' && item.amount == ''"
            >
              <span></span>
              <span>免</span>
            </div>
            <div class="ticketMoney" v-else>
              <span>￥</span>
              <span>{{ item.amount }}</span>
            </div>
            <div class="useMust" v-on:click="watchRule(item.use_rule)">
              {{ item.use_rule }}
            </div>
            <div class="ticketType">
              {{ item.category }}
            </div>
            <div class="ticketClick" v-on:click="ticketClick(item)">
              点击领取
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="searchBox">
      <div class="search">
        <img src="../assets/search.png" alt />
        <input type="text" id="searchShop" placeholder="输入店铺名称" />
      </div>
      <div class="clickSearch" v-on:click="toSearchShop">
        <img src="../assets/searchIcon.png" alt />
      </div>
    </div>
    <div
      class="ticketGood"
      :style="
        attionShopFirst.coupon_list && attionShopFirst.coupon_list.length > 0
          ? ''
          : 'margin-top:1rem'
      "
    >
      <div class="ticketTitle">
        超值优惠券 <img src="../assets/titleIcon.png" alt="" />
      </div>
      <div class="ticketGoodBox">
        <div
          class="TicketList"
          v-for="(item, index) in CouponGoodList"
          :key="index"
          :style="
              'background-image:url('+CShttp+item.shop_info.shop_images+')'
            "
        >
          <div
            class="TicketTop"
            
          >
            <div class="shopImg">
              <img :src="CShttp + item.shop_info.shop_icon_image" alt />
            </div>
            <div class="Name">
              <div class="NameText">{{ item.shop_info.name }}</div>
              <div class="shopInfo">
                <div>
                  <span>{{ item.shop_info.classname }}</span>
                  <span class="shopInfoCenter">|</span>
                  <span
                    >月销量{{
                      item.shop_info.xiaoliang ? item.shop_info.xiaoliang : 0
                    }}</span
                  >
                </div>
              </div>
              <div style="color: white">
                {{ (item.shop_juli[0].juli / 1000).toFixed(2) }}km
              </div>
            </div>
            <!-- <div>
              <div class="useGoodMust">{{ item.classname }}</div>
              <div
                class="useGoodMustText"
                v-on:click="watchRule(item.use_rule)"
              >
                {{ item.use_rule }}
              </div>
            </div> -->
          </div>
          <div class="TicketBottom">
            <div
              class="TickGoodMoney"
              style="margin-right: 0; margin-left: 0"
              v-if="item.category == '免费券' && !item.amount"
            >
              <span></span>
              <span>免</span>
            </div>
            <div class="TickGoodMoney" v-else>
              <span>￥</span>
              <span>{{ item.amount }}</span>
            </div>
            <div class="TickBottom" v-on:click="ticketClick(item)">
              点击领取
            </div>
          </div>

          <div class="CircleLeft"></div>
          <div class="CircleRight"></div>
        </div>
      </div>
    </div>
    <yd-tab class="tab" v-model="MycouponIndex" :callback="fn">
      <yd-tab-panel label="珍券推荐">
        <div
          class="tabTicket"
          v-for="(item, index) in RecommendList"
          :key="index"
        >
          <div class="tabTicketLeft">
            <!-- <div  v-if="item.category!='免费券'">
              <div class="TickGoodMoney" style="margin-right:0.5rem">
                <span>￥</span>
                <span v-if="item.category=='优惠券'||item.category=='礼品券'">{{item.amount}}</span>
              </div>
              <div style="text-align:center">{{item.category}}</div>
            </div>
            <div  v-if="item.category=='免费券'">
              <div
                class="TickGoodMoney"
                style="margin-right:0.5rem;margin-left:0;"
              >
                <span></span>
                <span>免</span>
              </div>
            </div>-->
            <!-- <div class="category">{{ item.category }}</div> -->
            <img :src="CShttp+item.shop_info.shop_images" alt="">
            <div class="tabTicketInfo">
              <div>·{{ item.shop_info.name }}</div>
              <div v-if="item.category == '免费券'">
                ·{{
                  item.name
                    ? "免费商品：" + item.name
                    : "免费金额：" + item.amount + "元"
                }}
              </div>
              <div v-else-if="item.category == '礼品券'">
                ·购：{{ item.gift }}
              </div>
              <div v-else-if="item.category == '优惠券'">
                ·满{{ item.reduce_rule }}
              </div>

              <div v-if="item.category == '免费券'">
                ·限领数量：{{ item.limitnumber }}
              </div>
              <div v-else-if="item.category == '礼品券'">
                ·送：{{ item.name }}
              </div>
              <div v-else-if="item.category == '优惠券'">
                ·减{{ item.amount }}
              </div>

              <div v-on:click="watchRule(item.use_rule)">
                ·{{ item.use_rule }}
              </div>
              <div>·核销截止：{{ item.end_time.substring(0, 11) }}</div>
            </div>
          </div>
          <div class="tabTicketRight">
            <!-- <div class="progressBox" v-if="item.surplus <= '10%'">
              <span>{{ item.surplus }}</span>
              <div :style="'width:' + item.surplus"></div>
            </div> -->
             <div class="TickGoodMoney">
              <span>￥</span>
              <span>{{ item.amount }}</span>
            </div>
            <div class="getCoupon" v-on:click="ticketClick(item)">领取</div>
          </div>
        </div>
      </yd-tab-panel>
      <yd-tab-panel label="附近好券">
        <div
          class="tabTicket"
          v-for="(item, index) in FJCouponList"
          :key="index"
        >
          <div class="tabTicketLeft">
            <!-- <div  v-if="item.category!='免费券'">
              <div class="TickGoodMoney" style="margin-right:0.5rem">
                <span>￥</span>
                <span v-if="item.category=='优惠券'||item.category=='礼品券'">{{item.amount}}</span>
              </div>
              <div style="text-align:center">{{item.category}}</div>
            </div>
            <div  v-if="item.category=='免费券'">
              <div
                class="TickGoodMoney"
                style="margin-right:0.5rem;margin-left:0;"
              >
                <span></span>
                <span>免</span>
              </div>
            </div>-->
            <div class="category">{{ item.category }}</div>
            <div class="tabTicketInfo">
              <div>·{{ item.shop_info.name }}</div>
              <div v-if="item.category == '免费券'">
                ·{{
                  item.name
                    ? "免费商品：" + item.name
                    : "免费金额：" + item.amount + "元"
                }}
              </div>
              <div v-else-if="item.category == '礼品券'">
                ·购：{{ item.gift }}
              </div>
              <div v-else-if="item.category == '优惠券'">
                ·满{{ item.reduce_rule }}
              </div>

              <div v-if="item.category == '免费券'">
                ·限领数量：{{ item.limitnumber }}
              </div>
              <div v-else-if="item.category == '礼品券'">
                ·送：{{ item.name }}
              </div>
              <div v-else-if="item.category == '优惠券'">
                ·减{{ item.amount }}
              </div>

              <div v-on:click="watchRule(item.use_rule)">
                ·{{ item.use_rule }}
              </div>
              <div>·核销截止：{{ item.end_time.substring(0, 11) }}</div>
            </div>
          </div>
          <div class="tabTicketRight">
            <!-- <div class="progressBox" v-if="item.surplus <= '10%'">
              <span>{{ item.surplus }}</span>
              <div :style="'width:' + item.surplus"></div>
            </div> -->
             <div class="TickGoodMoney">
              <span>￥</span>
              <span>{{ item.amount }}</span>
            </div>
            <div class="getCoupon" v-on:click="ticketClick(item)">点击领取</div>
          </div>
        </div>
      </yd-tab-panel>
      <yd-tab-panel label="更多券">
        <yd-tab
          horizontal-scroll
          style="width: 9rem"
          v-model="MycouponIndex2"
          :callback="fns"
        >
          <yd-tab-panel
            v-for="(item, index) in ShopClassList"
            :key="index"
            :label="item"
          >
            <div v-for="(ites, idx) in shopTypeList[index]" :key="idx">
              <div class="shopName" v-on:click="toShopIndex(ites)">
                <div class="shopImg">
                  <img :src="CShttp + ites.shop_icon_image" alt />
                </div>
                <div class="Name">
                  <div class="NameText">{{ ites.name }}</div>
                  <div class="shopInfo">
                    <div>
                      <span>{{ ites.shop_class_list }}</span>
                      <span class="shopInfoCenter">|</span>
                      <span
                        >月销量{{ ites.xiaoliang ? ites.xiaoliang : 0 }}</span
                      >
                    </div>
                    <div>{{ (item.juli / 1000).toFixed(2) }}km</div>
                  </div>
                </div>
              </div>
              <div
                class="swiperBox"
                style="margin-left: 0.15rem; width: 7.5rem"
              >
                <swiper :options="swiperOption" style="width: 100vw">
                  <swiper-slide
                    v-for="(coupon, idxs) in ites.coupon_list"
                    :key="idxs"
                  >
                    <div class="swiperTicket">
                      <div
                        class="ticketMoney"
                        v-if="
                          coupon.category == '免费券' && coupon.amount == ''
                        "
                      >
                        <span></span>
                        <span>免</span>
                      </div>
                      <div class="ticketMoney" v-else>
                        <span>￥</span>
                        <span>{{ coupon.amount }}</span>
                      </div>
                      <div
                        class="useMust"
                        v-on:click="watchRule(coupon.use_rule)"
                      >
                        {{ coupon.use_rule }}
                      </div>
                      <div class="ticketType">{{ coupon.category }}</div>
                      <div class="ticketClick" v-on:click="ticketClick(coupon)">
                        点击领取
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </yd-tab-panel>
        </yd-tab>
      </yd-tab-panel>
    </yd-tab>
    <Nav tabindex="0"></Nav>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import $ from "jquery";
export default {
  name: "",
  data() {
    return {
      attionShopFirst: "",
      FJCouponList: [], //附近好券列表
      CShttp: this.$store.state.CShttp,
      shopTypeList: [], //商店分类点击的全部数据
      shopTypeIndex: 0, //商店分类点击的坐标
      shopTypeName: "", //商店分类点击的类别
      ShopClassList: [], //更多券分类
      RecommendList: [], //珍券推荐列表
      CouponGoodList: [], //超值优惠券列表
      CouponList: [], //优惠券列表swiper
      shopShow: false, //首页店铺显示
      progress: 0.6, //进度条
      MycouponIndex: 0, //一级tab坐标
      MycouponIndex2: 0, //二级tab坐标
      //swiper左右滑动
      swiperOption: {
        slidesPerView: 3.5,
        // spaceBetween: 10,
        speed: 600, //config参数同swiper4,与官网一致
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
    Nav,
  },
  created() {},
  mounted() {
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    // var location = localStorage.getItem("ZQlocation")?):{"log":120.21848115098466,"lat":30.214433027298014};
    this.$store.commit(
      "location",
      JSON.parse(localStorage.getItem("ZQlocation"))
    );
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo,
    });
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;
    this.$store.commit(
      "UserSelf",
      JSON.parse(localStorage.getItem("ZQUserSelf"))
    );
    this.toActiveCoupon();
    this.ShareShop();
    this.getCoupon();
    this.giveTo();
    this.GetCouponList();
    this.GetCouponGoodList();
    this.GetMyFollow();
    this.GetRecommendList();
    this.GetShopClassListList();
  },
  methods: {
    // 查看规则
    watchRule(rule) {
      alert("券规则：" + rule);
    },
    toActiveCoupon() {
      var ActiveCoupon = localStorage.getItem("ActiveCoupon")
        ? JSON.parse(localStorage.getItem("ActiveCoupon"))
        : "";
      console.log("ActiveCoupon", ActiveCoupon);
      if (ActiveCoupon && ActiveCoupon.type == "ActiveCoupon") {
        localStorage.setItem("ActiveCoupon", "");
        this.$router.push({
          path: "/ActiveCoupon",
          query: {
            shop_id: ActiveCoupon.shop_id,
            active_id: ActiveCoupon.activeID,
            activeMoney: ActiveCoupon.activeMoney,
          },
        });
      }
    },
    //分享核销券
    giveTo() {
      var giveTo = localStorage.getItem("giveTo")
        ? JSON.parse(localStorage.getItem("giveTo"))
        : "";
      console.log("giveTo", giveTo);
      if (giveTo && giveTo.type == "giveTo") {
        localStorage.setItem("giveTo", "");
        this.$router.push({
          path: "/giveTo",
          query: { pcodes: giveTo.pcodes, id: giveTo.id },
        });
      }
    },
    //分享店铺
    ShareShop() {
      var shop = localStorage.getItem("shareShop")
        ? JSON.parse(localStorage.getItem("shareShop"))
        : "";
      console.log("shop", shop);
      if (shop && shop.type == "shopIndex") {
        localStorage.setItem("shareShop", "");
        this.$router.push({ path: "/shopIndex", query: { id: shop.id } });
      }
    },
    //分享优惠券
    getCoupon() {
      var item = localStorage.getItem("getCoupon")
        ? JSON.parse(localStorage.getItem("getCoupon"))
        : "";
      console.log("item", item);
      if (item && item.type == "getCoupon") {
        localStorage.setItem("getCoupon", "");
        this.ticketClick(item);
      }
    },
    //搜索店铺
    toSearchShop() {
      this.$router.push({
        path: "/searchShop",
        query: { value: $("#searchShop").val() },
      });
    },
    // 获取优惠券列表
    GetCouponList() {
      this.$http
        .get("/api/Coupon/list", {
          params: {},
        })
        .then((res) => {
          var List = res.data.data ? res.data.data.action : [];
          List.map((item) => {
            this.CouponList.push(item);
          });
        });
    },
    // 获取超值优惠券列表
    GetCouponGoodList() {
      this.$http
        .get("/api/Coupon/super_discount", {
          params: {
            log: this.$store.state.log,
            lat: this.$store.state.lat,
          },
        })
        .then((res) => {
          var TicketList = res.data.data ? res.data.data.action : [];
          TicketList.map((item) => {
            this.CouponGoodList.push(item);
          });
        });
    },
    // 获取珍券推荐列表
    GetRecommendList() {
      this.$http
        .get("/api/Coupon/recommend", {
          params: {},
        })
        .then((res) => {
          var TicketList = res.data.data.action;
          TicketList.map((item) => {
            this.RecommendList.push(item);
          });
        });
    },
    //领取优惠券
    ticketClick(item) {
      if (!this.$store.state.loading) {
        this.$store.commit("showLoading", true); //显示加载图标
        this.$http
          .get("/api/coupon/receive", {
            params: {
              uid: this.$store.state.useId,
              shop_id: item.shop_id,
              coupon_id: item.id,
            },
          })
          .then((res) => {
            if (res.data.code == 1) {
              this.$store.commit("showLoading", false); //关闭加载图标
              this.$store.commit("showMsg", {
                show: true,
                type: true,
                msg: "",
              }); //显示领取成功
            } else {
              this.$store.commit("showLoading", false); //关闭加载图标
              this.$store.commit("showMsg", {
                show: true,
                type: false,
                msg: res.data.msg,
              }); //显示领取失败
            }
          });
      }
    },
    //获取关注的商店
    GetMyFollow() {
      this.$http
        .get("/api/shop/get_frist_follow", {
          params: {
            uid: this.$store.state.useId,
            log: this.$store.state.log,
            lat: this.$store.state.lat,
          },
        })
        .then((res) => {
          if (!res.data.data || !res.data.data.action.id) {
            this.shopShow = false;
          } else {
            this.shopShow = true;
            res.data.data.action.juli = res.data.data.action.juli.toFixed(2);
            this.attionShopFirst = res.data.data.action;
          }
        });
    },
    //获取店铺分类
    GetShopClassListList() {
      this.$http
        .get("/api/shop/getShopClassListList", {
          params: {},
        })
        .then((res) => {
          console.log(res.data);
          for (var x in res.data) {
            this.ShopClassList.push(res.data[x]);
            this.shopTypeList.push([]);
          }
          this.shopTypeName = this.ShopClassList[0];
        });
    },
    //tab切换触发
    fn(label, key) {
      console.log(label, key);
      if (label == "更多券") {
        this.GetTypeList();
      }
      if (label == "附近好券") {
        this.GetFJList();
      }
    },
    fns(label, key) {
      console.log(label, key);
      this.shopTypeName = label;
      this.shopTypeIndex = key;
      this.GetTypeList();
    },
    //获取分类店铺信息列表
    GetTypeList() {
      console.log(this.shopTypeList[this.shopTypeIndex].length == 0);
      if (!this.$store.state.loading) {
        this.$store.commit("showLoading", true); //显示加载图标
        this.$http
          .get("/api/shop/getshop_list", {
            params: {
              name: this.shopTypeName,
            },
          })
          .then((res) => {
            res.data.data.action.map((res) => {
              this.shopTypeList[this.shopTypeIndex].push(res);
            });
            this.$store.commit("showLoading", false); //隐藏加载图标
          });
      }
    },
    //跳转商品详情页
    toShopIndex(item) {
      this.$router.push({ path: "/shopIndex", query: { id: item.id } });
    },
    //获取附近好券
    GetFJList() {
      if (!this.$store.state.loading) {
        this.$store.commit("showLoading", true); //显示加载图标
        this.$http
          .get("/api/Coupon/fujin_coupon", {
            params: {
              log: this.$store.state.log,
              lat: this.$store.state.lat,
            },
          })
          .then((res) => {
            if (res.data.code == 1) {
              console.log(res.data);
              this.FJCouponList = [];
              var FJCoupon = res.data.data.action;
              FJCoupon.map((item) => {
                this.FJCouponList.push(item);
              });
              this.$store.commit("showLoading", false); //关闭加载图标
            } else {
              this.$store.commit("showLoading", false); //关闭加载图标
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
  },
};
</script>
<style lang='scss' scoped>
#box {
  width: 100%;
  background-image: url(../assets/HomeBackGround.png);
  background-repeat: no-repeat;
  background-size: 100% 4.5rem;
  display: inline-block;
  margin-bottom: 1rem;
  background-color: white;
  padding-bottom: 0.3rem;
}
.TopNewBox {
  margin: 0.6rem 0.4rem 0 0.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.shopNameNew {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 2.4rem;
  height: 3.04rem;
  border-radius: 0.2rem;
  background-repeat: no-repeat;
  background-size: 100% 0.8rem;
  background-color: white;
}
.searchBox {
  height: 0.8rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // border: 2px solid #e22319;
  background: #ffeded;
  opacity: 0.9;
  border-radius: 0.4rem;
  padding-left: 0.3rem;
  font-size: 0.24rem;
  margin: 0.3rem 0.3rem 0 0.3rem;
}
.search {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.searchBox img {
  width: 0.5rem;
  height: 0.5rem;
  display: inline-block;
  margin-right: 0.2rem;
}
.searchBox input {
  border: none;
  outline: none;
  -webkit-appearance: none;
}
.clickSearch img {
  width: 0.5rem;
  height: 0.5rem;
  margin: 0.15rem 0.34rem;
}
.shopName {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 0 0.3rem;
  padding-top: 0.63rem;
}
.backShow {
  width: 100%;
  height: 2.3rem;
  background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.5));
  position: absolute;
  left: 0;
  top: 0;
}
.shopJuli {
  font-size: 0.24rem;
  background: #f2f2f2;
  border-radius: 0.2rem;
  width: 1.2rem;
  height: 0.42rem;
  line-height: 0.42rem;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 0.2rem;
  margin-top: 0.12rem;
  color: #666;
}
.shopName > .shopImg {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 100%;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 100;
  box-shadow: 2px 2px 5px #e5e5e5;
}
.shopImg > img {
  width: 0.8rem;
  height: 0.8rem;
  flex-shrink: 0;
  margin-top: 0.4rem;
  border-radius: 0.2rem;
}
.Name {
  width: 100%;
  position: relative;
}
.NameText {
  font-size: 0.28rem;
  line-height: 0.38rem;
  font-weight: 700;
  text-align: center;
  margin-top: 0.12rem;
}
.shopInfo {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.24rem;
  color: #636363;
  height: 0.4rem;
}
.yd-tab-panel-item .shopImg > img{
  margin: 0;
  width: 100%;
  height: 100%;
}
.yd-tab-panel-item .shopName{
   justify-content: flex-start;
}
.yd-tab-panel-item .Name>div{
  text-align: left;
  display: block;
   padding-left: 0.2rem;
}
.topLogo {
  width: 4.1rem;
  height: 3.04rem;
  border-radius: 0.2rem;
}
.shopInfoCenter {
  display: inline-block;
  margin: 0 0.1rem;
}
.swiperBox {
  margin-left: 0.3rem;
  margin-top: 0.3rem;
  // margin-right: 0.3rem;
}
.swiperTicket {
  width: 1.8rem;
  height: 2.46rem;
  // background-image: url(../assets/ticket01.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: #fff2e4;
  border-radius: 0.2rem;
  padding-top: 0.1rem;
  border: 3px solid #d89448;
}
.swiperTicket > div {
  text-align: center;
}
.ticketMoney {
  line-height: 0.78rem;
  font-size: 0.5rem;
  color: #4a0300;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  border-bottom: 1px dashed #000;
  margin: 0 0.2rem;
  margin-bottom: 0.1rem;
}
.ticketMoney > span:nth-child(1) {
  font-size: 0.28rem;
  line-height: 0.6rem;
}
.useGoodMust,
.useMust {
  // background: #fcd4d2;
  font-size: 0.22rem;
  // color: #cc1a1a;
  margin: 0 0.1rem;
  border-radius: 0.2rem;
  height: 0.34rem;
  line-height: 0.34rem;
  overflow: hidden;
  /*不换行*/
  white-space: nowrap;
  /*添加...*/
  text-overflow: ellipsis;
}
.useMust {
  padding: 0 0.05rem;
}
.ticketType {
  font-size: 0.2rem;
  color: #333;
  line-height: 0.3rem;
  height: 0.3rem;
  margin: 0.08rem auto;
  // border: 1px solid #333;
  border-radius: 0.3rem;
  width: 1.2rem;
  padding-left: 0.2rem;
  background-image: url(../assets/couponBack.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.ticketClick {
  font-size: 0.28rem;
  line-height: 0.42rem;
  color: #fff;
  background-color: #d54e50;
  width: 1.2rem;
  border-radius: 0.3rem;
  height: 0.42rem;
  font-size: 0.22rem;
  margin: 0 auto;
}
.ticketGood {
  margin: 0.34rem 0.3rem 0 0.3rem;
}
.ticketTitle {
  font-size: 0.3rem;
  color: #333;
  line-height: 0.75rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-weight: 600;
}
.ticketTitle img {
  width: 0.5rem;
  height: 0.3rem;
  margin-left: 0.1rem;
}
.ticketGoodBox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.TicketList {
  width: 49%;
  // height: 2.1rem;
  // background-image: url(../assets/ticketGood01.png);
  background-size: 100% 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 0.1rem;
  border-radius: 0.3rem;
  overflow: hidden;
  background-size: 100% 1.08rem;
  background-repeat: no-repeat;
  position: relative;
}
.CircleLeft,.CircleRight{
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 100%;
  background-color: white;
  position: absolute;
  // z-index: 100;
}
.CircleLeft{
  left: -0.2rem;
  top: 0.88rem;
}
.CircleRight{
  right: -0.2rem;
  top: 0.88rem;
}
.TicketList:nth-child(1) {
  margin-bottom: 0.1rem;
  // margin-right: 0.1rem;
}
// .TicketList:nth-child(2) {
//   background-image: url(../assets/ticketGood02.png);
// }
// .TicketList:nth-child(3) {
//   background-image: url(../assets/ticketGood03.png);
// }
// .TicketList:nth-child(4) {
//   margin-left: 0.1rem;
//   background-image: url(../assets/ticketGood04.png);
// }
.TicketTop .NameText {
  color: white;
  text-align: left;
  line-height: 0.3rem;
  height: 0.3rem;
  font-size: 0.28rem;
  margin: 0;
}
.TicketTop .shopInfo {
  color: white;
  line-height: 0.3rem;
  font-size: 0.22rem;
  height: 0.3rem;
  justify-content: flex-start;
}
.TicketTop .shopImg > img {
  border-radius: 100%;
  margin-top: 0;
  margin: 0 0.2rem;
}
.TicketBottom .TickGoodMoney span{
  color: #1e1e1e !important;
}
.TicketBottom .TickBottom{
  border-radius: 0.3rem;
  background-color: #323232;
  width: 1.2rem;
  font-size: 0.22rem;
  padding: 0;
  height: 0.42rem;
  line-height: 0.42rem;
  margin-right: 0.25rem;
}
.TicketList:nth-child(3) .useGoodMust,
.TicketList:nth-child(4) .useGoodMust {
  color: #621099;
}
.TicketTop {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 1.08rem;
  background-color: rgba(0, 0, 0, 0.3);
  border-bottom-left-radius: -0.2rem;
  // padding-top: 0.32rem;
}
.TicketBottom {
  height: 0.9rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5cc9e;
}
.TickGoodMoney {
  width: 1.26rem;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin: 0 0.1rem;
}
.TickGoodMoney > span:nth-child(1) {
  font-size: 0.26rem;
  color: #ffffff;
  margin-bottom: 0.1rem;
}
.TickGoodMoney > span:nth-child(2) {
  font-size: 0.5rem;
  color: #ffffff;
}
.useGoodMust {
  display: block;
  width: 1rem;
  height: 0.35rem;
  text-align: center;
  line-height: 0.35rem;
  color: #dd352c;
  background: rgba(255, 255, 255, 0.7);
}
.useGoodMustText {
  font-size: 0.2rem;
  color: #ffffff;
  opacity: 0.7;
  line-height: 0.32rem;
  height: 0.32rem;
  margin-top: 0.1rem;
  overflow: hidden;
  /*不换行*/
  white-space: nowrap;
  /*添加...*/
  text-overflow: ellipsis;
  width: 1.8rem;
}
.TickBottom {
  font-size: 0.28rem;
  text-align: center;
  color: #ffffff;
  line-height: 0.68rem;
}
.tab {
  margin-top: 0.34rem;
}
.yd-tab .yd-tab-nav-nomal .yd-tab-active {
  color: #cd160d;
}
.tabTicket {
  // background-image: url(../assets/tabTicket.png);
  background-color: #e73d35;
  border-radius: 0.3rem;
  height: 1.68rem;
  background-size: 100% 100%;
  margin-top: 0.2rem;
  margin-left: 0.2rem;
  margin-right: 0.2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tabTicket .tabTicketLeft {
  height: 100%;
  padding-left: 0.3rem;
  color: #ffe5a6;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.tabTicket .tabTicketLeft .TickGoodMoney > span {
  color: #ffe5a6;
}
.tabTicketLeft >img{
  width: 0.86rem;
   height: 0.86rem;
   flex-shrink: 0;
   border-radius: 100%;
   margin-right: 0.2rem;
}
.tabTicketInfo div {
  font-size: 0.2rem;
  line-height: 0.32rem;
  height: 0.32rem;
  width: 2.5rem;
  overflow: hidden;
  /*不换行*/
  white-space: nowrap;
  /*添加...*/
  text-overflow: ellipsis;
}
.tabTicketRight {
  width: 1.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-left: 1px dotted #f5cc9e;
}
.progressBox {
  width: 1.78rem;
  height: 0.32rem;
  background: white;
  border-radius: 0.2rem;
  margin-top: 0.2rem;
  text-align: center;
  position: relative;
  color: #be1910;
  overflow: hidden;
}
.progressBox > div {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 100%;
  border-radius: 0.2rem;
  background-color: #ffe5a6;

  font-size: 0.28rem;
  display: flex;
  justify-content: flex-end;
}
.progressBox > span {
  margin: 0 auto;
  width: 0.4rem;
  height: 0.32rem;
  line-height: 0.32rem;
  z-index: 1000;
  position: absolute;
  left: 50%;
  top: 0;
  margin-left: -0.2rem;
}
.tabTicketRight > .getCoupon {
  font-size: 0.2rem;
  color: #bd1810;
  // line-height: 0.3rem;
  width: 1.2rem;
  height: 0.3rem;
  background-color: #f5cc9e;
  border-radius: 0.3rem ;
  text-align: center;
}
.tabTicketRight .TickGoodMoney>span{
  margin-bottom: 0.1rem;
   color: #f5cc9e !important;
}
.tab .yd-tab-nav-scoll {
  background-color: #f5f5f5 !important;
}
.yd-tab-panel {
  background: white;
}
.yd-tab-panel .shopName {
  padding: 0.3rem 0.3rem 0 0.3rem;
  color: black;
}
.yd-tab-panel .shopName .NameText {
  color: black;
  font-weight: 500;
  line-height: 0.4rem;
  margin-top: 0.2rem;
}
.yd-tab-panel .swiperBox {
  margin-top: 0.2rem;
}
.tab .yd-tab-panel .yd-tab-panel-item {
  background-color: white;
}
.swiper-container {
  margin-left: 0 !important;
}
.category {
  width: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.32rem;
  color: #ffe5aa;
}
</style>

